"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WF_DATA_TEST_IDS = void 0;
var WF_DATA_TEST_IDS;
(function (WF_DATA_TEST_IDS) {
    WF_DATA_TEST_IDS["WORKFLOW_STEPS_CONTAINER"] = "WorkflowStepsContainer";
    WF_DATA_TEST_IDS["WORKFLOW_BTNS_WEB"] = "WorkflowBtnsWebView";
    WF_DATA_TEST_IDS["WORKFLOW_BTNS_MOBILE"] = "WorkflowBtnsMobileView";
    WF_DATA_TEST_IDS["WORKFLOW_BTNS_NATIVE"] = "WorkflowBtnsNativeView";
    WF_DATA_TEST_IDS["WORKFLOW_CANCEL_BTN"] = "WorkflowCancelBtn";
    WF_DATA_TEST_IDS["WORKFLOW_BACK_BTN"] = "WorkflowBackBtn";
    WF_DATA_TEST_IDS["WORKFLOW_CONT_BTN"] = "WorkflowContBtn";
    WF_DATA_TEST_IDS["WORKFLOW_SUBMIT_BTN"] = "WorkflowSubmitBtn";
    WF_DATA_TEST_IDS["WORKFLOW_CLOSE_BTN"] = "WorkflowCloseBtn";
})(WF_DATA_TEST_IDS = exports.WF_DATA_TEST_IDS || (exports.WF_DATA_TEST_IDS = {}));
